import { useSelector } from '../../context/hooks';
import { selectMeter, selectIncludedAllowance } from '../../context/selectors';
import { useCollectionDescriptions } from '../product-descriptions';
import { METER_LABELS } from '../strings';

import { EDITIONS } from './common/edition-options';
import { ProductCard } from './common/product-card';
import { useProductCardData } from './common/use-product-card-data';

export const TeamworkCollectionProductCard = () => {
	const { shortDescription, list } = useCollectionDescriptions().teamworkCollection;
	const meter = useSelector(selectMeter);
	const allowance = useSelector(selectIncludedAllowance);
	const additionalBenefit = `${allowance.toLocaleString('en-US')} ${METER_LABELS[meter]}`;
	return (
		<ProductCard
			{...useProductCardData('teamworkCollection')}
			title="Teamwork Collection"
			description={shortDescription}
			list={list}
			unitLabelPlural="users"
			unitLabelSingular="user"
			editions={EDITIONS}
			additionalBenefit={additionalBenefit}
		/>
	);
};
